import React from 'react'
import { createPortal } from 'react-dom'
import type { FC, TeactNode } from '../../lib/teact/teact'
import { useMemo } from '../../lib/teact/teact'

type OwnProps = {
  containerId?: string
  className?: string
  children: TeactNode
}

const Portal: FC<OwnProps> = ({ containerId, className, children }) => {
  const container = useMemo(() => document.querySelector<HTMLDivElement>(containerId || '#portals'), [containerId])

  return container ? createPortal(<div className={className}>{children}</div>, container) : null
}

export default Portal
